module.exports = __webpack_public_path__ + "static/media/favourite_2.cbaba3d2.png";